export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["None"] = "None";
    DeliveryType["Pickup"] = "Pickup";
    DeliveryType["Delivery"] = "Delivery";
})(DeliveryType || (DeliveryType = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Cash"] = "Cash";
    PaymentType["Lease"] = "Lease";
    PaymentType["Loan"] = "Loan";
})(PaymentType || (PaymentType = {}));
